import { render } from "./presupuestoCard.vue?vue&type=template&id=35b3bb98&scoped=true"
import script from "./presupuestoCard.vue?vue&type=script&lang=js"
export * from "./presupuestoCard.vue?vue&type=script&lang=js"

import "./presupuestoCard.vue?vue&type=style&index=0&id=35b3bb98&lang=css"
import "./presupuestoCard.vue?vue&type=style&index=1&id=35b3bb98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b3bb98"]])

export default __exports__